import api from "./api.js";

export default class PopupApi {
  static async getActivePopup() {
    return await api.get(`api/popup`, {
      page: 1,
      size: 0,
      activation: "Active",
    });
  }
}
